module.exports = __webpack_public_path__ + "img/industry_disable.b37632e.png";